import type { TableSort } from "./adminTableSort";

export type VoiceSort = TableSort<"name" | "gemini" | "tags" | "language_code" | "region_code" | "accent" | "gender" | "pitch" | "created_at">;
type PreferenceStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;
const preferenceKey = (userId: string) => `tableread.admin.voices.sort.v1:${userId}`;

export function readVoiceSort(userId?: string, storage?: PreferenceStorage): VoiceSort | null {
  if (!userId) return null;
  try {
    const store = storage ?? (typeof window !== "undefined" ? window.localStorage : null);
    const value: unknown = JSON.parse(store?.getItem(preferenceKey(userId)) ?? "null");
    if (!value || typeof value !== "object" || Array.isArray(value)) return null;
    const sort = value as Record<string, unknown>;
    if (!["name", "gemini", "tags", "language_code", "region_code", "accent", "gender", "pitch", "created_at"].includes(String(sort.key)) ||
      (sort.direction !== "ascending" && sort.direction !== "descending")) return null;
    return { key: sort.key as VoiceSort["key"], direction: sort.direction };
  } catch {
    return null; // Corrupt preferences or blocked storage must not prevent loading Voices.
  }
}

export function writeVoiceSort(userId: string | undefined, sort: VoiceSort | null, storage?: PreferenceStorage): void {
  if (!userId) return;
  try {
    const store = storage ?? (typeof window !== "undefined" ? window.localStorage : null);
    if (sort) store?.setItem(preferenceKey(userId), JSON.stringify(sort));
    else store?.removeItem(preferenceKey(userId));
  } catch {
    // Sorting still works for this visit when browser persistence is unavailable.
  }
}
